export default __webpack_public_path__ + "static/talentkick_neg_farbe_NEU-079da58a77a9d7a85edf6a2f3cb8cbe7.webp";